import styled from 'styled-components'

export const Root = styled.div``

export const TitleWrapper = styled.div`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.bold};
  `}
`
